import React from 'react';
import '../App.css';

const Home = () => {
  return (
    <section className="home-page">
      {/* Placeholder para banner principal */}
      <div className="banner-placeholder">
        <h2>¡Bienvenido a tu tienda pastel!</h2>
        <p>Descubre productos increíbles en un entorno visualmente suave y moderno.</p>
      </div>
      {/* Placeholder para productos destacados */}
      <div className="featured-products-placeholder">
        <h3>Productos Destacados</h3>
        <div className="products-grid">
          <div className="product-card-placeholder">Producto 1</div>
          <div className="product-card-placeholder">Producto 2</div>
          <div className="product-card-placeholder">Producto 3</div>
        </div>
      </div>
    </section>
  );
};

export default Home; 